module.exports = __webpack_public_path__ + "img/layout.8a437d55.svg";